import { useMemo } from 'react';
import { type SWRResponse } from 'swr';

import { type SwrKey, type UseNoodleSwrConfig, useNoodleSwr } from '@/hooks/useNoodleApi';
import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/petition-settings/{creatorId}';
type ThisApi = ApiDefinition[typeof PATH_TEMPLATE]['GET'];
type Input = ThisApi['params'];
type Output = ThisApi['response'];

/** SWR hook for loading creator petition settings. */
export const usePetitionSettings = (params: Input | null, config?: UseNoodleSwrConfig<Output>): SWRResponse<Output> => {
  const key = useMemo((): SwrKey => {
    if (!params) return null;
    return buildPath<ThisApi>(PATH_TEMPLATE, params);
  }, [params]);

  return useNoodleSwr<Output>(key, { revalidateOnFocus: false, ...config });
};

/** Loads creator petition settings. */
const getPetitionSettings = async ({ creatorId }: Input): Promise<Output> => {
  const path = buildPath<ThisApi>(PATH_TEMPLATE, { creatorId });
  const response = await noodleApiClient.get(path);
  return response.data as Output;
};

export default getPetitionSettings;
